import { createSlice } from "@reduxjs/toolkit";
import {
  authChangePassword,
  coachCreateOffer,
  coachDeleteAccount,
  coachDeleteContent,
  coachDisableAccount,
  coachPlanCancel,
  createContent,
  deleteOffer,
  editContent,
  editOffer,
  fetchAllCoachOffers,
  fetchCoachingDashboard,
  fetchCoachList,
  fetchCoachProfileData,
  fetchCoachSubscription,
  fetchContent,
  fetchNuterraDetailsById,
  fetchWebinarDetailsById,
  fetchWorkshopeDetailsById,
  updateProfile,
  updateCoachProfileExtended,
} from "../actions/coachAction";

const initialState = {
  isLoading2: false,
  resourceHeader: [
    "S.No.",
    "Title",
    "Type",
    "Status",
    "Submitted On",
    "Visibility",
    "Action",
  ],
  coachList: [],
  coachSubscriptionPlan: [],
  coachProfile: {},
  coachOfferList: [],
  coachingDashboardData: {},
  contentList: {},
  workshopDetail: {},
  webinarDetail: {},
  nuterraDetail: {},
};

const coachSlice = createSlice({
  name: "coach",
  initialState: initialState,
  extraReducers: (builder) => {
    // fetchCoachList
    builder.addCase(fetchCoachList.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchCoachList.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.coachList = data ?? [];
      state.isLoading2 = false;
    });
    builder.addCase(fetchCoachList.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchCoachSubscription
    builder.addCase(fetchCoachSubscription.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchCoachSubscription.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.coachSubscriptionPlan = data ?? [];
      state.isLoading2 = false;
    });
    builder.addCase(fetchCoachSubscription.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // authChangePassword
    builder.addCase(authChangePassword.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(authChangePassword.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(authChangePassword.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // coachDisableAccount
    builder.addCase(coachDisableAccount.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(coachDisableAccount.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(coachDisableAccount.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // coachDeleteAccount
    builder.addCase(coachDeleteAccount.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(coachDeleteAccount.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(coachDeleteAccount.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // coachPlanCancel
    builder.addCase(coachPlanCancel.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(coachPlanCancel.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(coachPlanCancel.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchCoachProfileData
    builder.addCase(fetchCoachProfileData.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchCoachProfileData.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.coachProfile = data ?? {};
      state.isLoading2 = false;
    });
    builder.addCase(fetchCoachProfileData.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // updateProfile
    builder.addCase(updateProfile.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(updateProfile.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // updateCoachProfileExtended
    builder.addCase(updateCoachProfileExtended.pending, (state) => {
      state.isLoading2 = true;
    });
    builder.addCase(updateCoachProfileExtended.fulfilled, (state) => {
      state.isLoading2 = false;
    });
    builder.addCase(updateCoachProfileExtended.rejected, (state) => {
      state.isLoading2 = false;
    });

    // coachCreateOffer
    builder.addCase(coachCreateOffer.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(coachCreateOffer.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(coachCreateOffer.rejected, (state, action) => {
      state.isLoading2 = false;
    });
    // editOffer
    builder.addCase(editOffer.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(editOffer.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(editOffer.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchAllCoachOffers
    builder.addCase(fetchAllCoachOffers.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchAllCoachOffers.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.coachOfferList = data || [];
      state.isLoading2 = false;
    });
    builder.addCase(fetchAllCoachOffers.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchContent
    builder.addCase(fetchContent.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchContent.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      const grouped = Object?.groupBy(data, (p) => p?.content_type);
      state.contentList = {
        all: data,
        ...grouped,
      };
      state.isLoading2 = false;
    });
    builder.addCase(fetchContent.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // createContent
    builder.addCase(createContent.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(createContent.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(createContent.rejected, (state, action) => {
      state.isLoading2 = false;
    });
    // coachDeleteContent
    builder.addCase(coachDeleteContent.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(coachDeleteContent.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(coachDeleteContent.rejected, (state, action) => {
      state.isLoading2 = false;
    });
    // editContent
    builder.addCase(editContent.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(editContent.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(editContent.rejected, (state, action) => {
      state.isLoading2 = false;
    });
    // deleteOffer
    builder.addCase(deleteOffer.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(deleteOffer.fulfilled, (state, action) => {
      state.isLoading2 = false;
    });
    builder.addCase(deleteOffer.rejected, (state, action) => {
      state.isLoading2 = false;
    });


    // fetchCoachingDashboard
    builder.addCase(fetchCoachingDashboard.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchCoachingDashboard.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.coachingDashboardData = data || {};
      state.isLoading2 = false;
    });
    builder.addCase(fetchCoachingDashboard.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchWorkshopeDetailsById
    builder.addCase(fetchWorkshopeDetailsById.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchWorkshopeDetailsById.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.workshopDetail = data || {};
      state.isLoading2 = false;
    });
    builder.addCase(fetchWorkshopeDetailsById.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchWebinarDetailsById
    builder.addCase(fetchWebinarDetailsById.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchWebinarDetailsById.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      state.webinarDetail = data || {};
      state.isLoading2 = false;
    });
    builder.addCase(fetchWebinarDetailsById.rejected, (state, action) => {
      state.isLoading2 = false;
    });

    // fetchNuterraDetailsById
    builder.addCase(fetchNuterraDetailsById.pending, (state, action) => {
      state.isLoading2 = true;
    });
    builder.addCase(fetchNuterraDetailsById.fulfilled, (state, action) => {
      const { data } = action?.payload ?? {};
      console.log({ data });
      state.nuterraDetail = data || {};
      state.isLoading2 = false;
    });
    builder.addCase(fetchNuterraDetailsById.rejected, (state, action) => {
      state.isLoading2 = false;
    });
  },
});

export default coachSlice.reducer;
